"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ArrowLeftTraySolid: function() {
        return ArrowLeftTraySolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ArrowLeftTraySolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H12C11.4477 22 11 21.5523 11 21V15.0014L16.0008 15C17.6577 14.9995 19.0005 13.656 19 11.9992C18.9995 10.3423 17.656 8.99954 15.9992 9L11 9.00139V3C11 2.44772 11.4477 2 12 2H19Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M6.29289 7.29289C6.68342 6.90237 7.31658 6.90237 7.70711 7.29289C8.09763 7.68342 8.09763 8.31658 7.70711 8.70711L5.41127 11.0029L15.9997 11C16.552 10.9998 16.9998 11.4474 17 11.9997C17.0002 12.552 16.5526 12.9998 16.0003 13L5.41715 13.0029L7.70711 15.2929C8.09763 15.6834 8.09763 16.3166 7.70711 16.7071C7.31658 17.0976 6.68342 17.0976 6.29289 16.7071L2.34533 12.7595C2.13387 12.5763 2.00009 12.3057 2 12.0039V12.0027C1.99933 11.7458 2.09696 11.4888 2.29289 11.2929L6.29289 7.29289Z",
            fill: "currentColor"
        })
    ]
}), "ArrowLeftTraySolid");
const _default = ArrowLeftTraySolid;
